import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import Container from 'Components/Atoms/Container/Container';
import Loader from 'Components/Atoms/Loader/Loader';
import { SearchUsers } from 'Components/Atoms/SearchUsers/SearchUsers';
import Title from 'Components/Atoms/Title/Title';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import PageHeader from 'Components/Organisms/PageHeader/PageHeader';
import { UserManagement } from 'Components/Organisms/UserManagement/UserManagement';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { ROUTE } from 'Services/Route/Route.types';
import { fetchAllScopes } from 'Store/Api/Actions';
import { StoreState } from 'Store/Reducers';
import { addUserPermission, blockUser, deleteUserPermission, fetchUserPermissions, fetchUsers, resetUserPermission, saveUserPermissions, unblockUser } from 'Store/User/Actions';
import { getUsers } from 'Store/User/Selectors';

const UsersPage = ({
    users,
    ...props
}: UsersPageProps) => {
    const [isFetchingUsers, setFetchingUsers] = useState(true);
    const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
    const [searchFilter, setSearchFilter] = useState('');

    useEffect(() => {
        props.fetchUsers();
    }, []);

    useEffect(() => {
        setFilteredUsers(users);
    }, [users]);

    const filter = (e: any) => {
        const filterValue = e;
        setSearchFilter(filterValue);

        const filtered = users?.filter((user: any) => user.name.toLowerCase().includes(filterValue));
        setFilteredUsers(filtered ?? users);
    }

    return <PageTemplate>
        <Helmet>
            <title>Gebruikers - App Growing People B.V.</title>
        </Helmet>
        
        <PageHeader
            breadcrumbs={
                <Breadcrumbs>
                    <BreadcrumbItem path={ROUTE.DASHBOARD}>Home</BreadcrumbItem>
                    <BreadcrumbItem path={ROUTE.SETTINGS}>Instellingen</BreadcrumbItem>
                    <BreadcrumbItem>Gebruikers</BreadcrumbItem>
                </Breadcrumbs>
            }
        >
            <Title
                size='large'
                weight='bold'
            >
                Gebruikers
            </Title>
        </PageHeader>

        <Container padding='vertical'>
            <SearchUsers searchFilter={searchFilter} onChange={filter}/>
            { users && <>
                <UserManagement users={filteredUsers} />
            </> }
            { !users && <Loader description='Gebruikers laden...' />}
        </Container>
    </PageTemplate>
}

interface Props {

}

const mapState = (state: StoreState) => ({
    users: getUsers(state)
});

const mapDispatch = {
    fetchUsers,
    blockUser,
    unblockUser,
    fetchAllScopes,
    fetchUserPermissions,
    addUserPermission,
    deleteUserPermission,
    resetUserPermission,
    saveUserPermissions
}

type UsersPageProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(UsersPage);